import {Component, OnInit, Input, Output, TemplateRef, EventEmitter, OnDestroy} from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { SellSearchState } from 'remarketing-angular-library';
import { TranslocoDirective } from '@jsverse/transloco';
import { SearchFilterComponent } from '../search-filter.component';
import {
  UtilityBarDateRangeComponent
} from '../../utility-bar/utility-bar-date-range/utility-bar-date-range.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-mobile-search-filter',
    templateUrl: './mobile-search-filter.component.html',
    styleUrls: ['./mobile-search-filter.component.scss'],
    imports: [TranslocoDirective, SearchFilterComponent, UtilityBarDateRangeComponent, CommonModule]
})
export class MobileSearchFilterComponent implements OnInit, OnDestroy {
  @Input() showDateRange: boolean;
  @Output() closed = new EventEmitter<boolean>();
  resultsString: string;
  count: number;
  private destroyed$ = new Subject();

  constructor(private store: Store) {}

  ngOnInit() {
    this.store
      .select(SellSearchState.searchResponse)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        searchResponse => {
          if (searchResponse) {
            this.resultsString = this.resultCountString(searchResponse.totalItems);
            this.count = searchResponse.totalItems;
          }
        },
        () => {
          // error handler
        }
      );
  }

  backClicked() {
    this.closed.emit();
  }

  // openSaveSearchModal(modalId: string) {
  //   MicroModal.show(modalId, {
  //     disableScroll: true
  //   });
  //   const heading = document.querySelector(`#${modalId} h1`) as HTMLElement;
  //   if (heading) {
  //     heading.focus();
  //   }
  // }

  resultCountString(count) {
    if (count === 0 || count > 1) {
      return `${count} Results`;
    } else if (count === 1) {
      return '1 Result';
    } else {
      return '';
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
